/* You can add your custom scripts here */


var productOptionPickerLists = document.querySelectorAll('.product-option-picker__list');

for (let productOptionPickerList of productOptionPickerLists) {
  if( productOptionPickerList.dataset.optionName == 'Color' ){
    console.log('Color', productOptionPickerList.dataset.optionValue);
    chosenColor(productOptionPickerList.dataset.optionValue);

    var productOptionListItems = productOptionPickerList.querySelectorAll('.product-option-picker__list-item');

    for (let productOptionListItem of productOptionListItems) {
      
      productOptionListItem.addEventListener('click', function(){
        console.log('Color', this.dataset.optionValue);
          chosenColor(this.dataset.optionValue);
      })
      
    }
  }
}

function chosenColor(color){
  var productThumbnails = document.querySelectorAll('.product-gallery-thumbnails img');
  for (let productThumbnail of productThumbnails) {
    console.log( 'thumbnail alt', productThumbnail.parentElement.parentElement );
    // vat thumbnailParent = productThumbnail.parentElement.parentElement;
      productThumbnail.classList.remove('hide');
    if( productThumbnail.getAttribute('alt') !== color ){
      productThumbnail.classList.add('hide');
    }
  }
}



var popupCards = document.querySelectorAll('.popup-card');
console.log('Popup cards', popupCards);

for (let popupCard of popupCards){
  var popupTrigger = popupCard.querySelector('.popup-card-trigger');
  var popupClose = popupCard.querySelector('.popup-card-close');
  var popupOverlay = popupCard.querySelector('.popup-card-overlay');

  popupTrigger.addEventListener('click', function(){
    popupCard.classList.add('active');
  })

  
  popupOverlay.addEventListener('click', function(){
    popupCard.classList.remove('active');
  })
  popupClose.addEventListener('click', function(){
    popupCard.classList.remove('active');
  })
  
}